import React from "react";
import { useTranslations } from "@harea/component";

const Page404 = () => {
    const [SUBTITLE, DESCRIPTION, BACK_TO_HOME] = useTranslations(i18n);

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-white px-6 py-10">
            <div className="relative w-full max-w-6xl overflow-hidden rounded-[28px] bg-[#F6F6F4]">
                {/* Grille en lignes fines */}
                <div
                    className="absolute inset-0 opacity-70"
                    style={{
                        backgroundImage:
                            "linear-gradient(to right, #e9e9e6 1px, transparent 1px), linear-gradient(to bottom, #e9e9e6 1px, transparent 1px)",
                        backgroundSize: "40px 40px",
                    }}
                    aria-hidden="true"
                />
                {/* Voile pour estomper la grille sur les bords */}
                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "radial-gradient(ellipse at center, transparent 40%, #F6F6F4 90%)",
                    }}
                    aria-hidden="true"
                />

                <div className="relative flex items-center justify-between gap-6 px-10 py-16 md:px-16 md:py-20">
                    {/* Colonne texte */}
                    <div className="max-w-md shrink-0">
                        <span className="text-[13px] text-slate-500">
                            404 Not Found
                        </span>

                        <h1 className="mt-3 text-[32px] font-extrabold leading-[1.15] text-slate-900 md:text-[36px]">
                            {SUBTITLE}
                        </h1>

                        <p className="mt-4 text-[14px] leading-relaxed text-slate-500">
                            {DESCRIPTION}
                        </p>

                        <a
                            href="/"
                            className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#1C1C1C] py-2 pl-5 pr-2 text-[11px] font-semibold uppercase tracking-wider text-white transition hover:bg-black"
                        >
                            {BACK_TO_HOME}
                            <span className="flex h-6 w-6 items-center justify-center rounded-full border border-white text-white">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    className="h-3.5 w-3.5"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M5 12h14m-6-6l6 6-6 6"
                                    />
                                </svg>
                            </span>
                        </a>
                    </div>

                    {/* Gros 404, légèrement coupé à droite */}
                    <div className="pointer-events-none -mr-6 select-none text-[9rem] font-black leading-none tracking-tight text-[#4B4B4B] md:-mr-10 md:text-[13rem]">
                        404
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Page404;

const i18n = ["std_error_404", "std_error_404_description", "std_back_to_home"];